/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_NOTIFICATION_CHANNELS = gql`
  query GetNotificationChannels {
    notificationChannels
  }
`
